// Route Code Edited 3/24/26

/* ============================================================
 * Route Bfcache Handler - PART 2
 *
 * Loaded with defer
 * Handles the Route line item cleanup on the fresh load
 * that follows a bfcache restore, and covers popstate as a fallback.
 * ============================================================ */

(function () {
  const CART_PATH    = /\/cart\/?$/;
  const CLEANUP_FLAG = 'route_pending_cart_cleanup';

  function isCartPage() {
    return CART_PATH.test(location.pathname);
  }

  // Remove Route line item on the fresh load after a bfcache restore.
  // Page is hidden during cleanup to mask the Route item briefly appearing in the cart.
  function runPendingCleanup() {
    if (!sessionStorage.getItem(CLEANUP_FLAG)) return;
    sessionStorage.removeItem(CLEANUP_FLAG);

    fetch('/cart.js')
      .then(res => res.ok ? res.json() : Promise.reject(res.status))
      .then(cart => {
        const route = (cart.items || []).find(item => item.vendor === 'Route');
        if (!route?.key) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: { [route.key]: 0 } })
        }).then(() => location.reload());
      })
      .catch(err => console.error('[Route] Cart cleanup failed:', err));
  }

  // popstate fallback for back/forward not served from bfcache
  function handlePopstate() {
    setTimeout(() => {
      if (!isCartPage()) return;
      sessionStorage.setItem(CLEANUP_FLAG, '1');
      location.reload();
    }, 50);
  }

  runPendingCleanup();
  addEventListener('popstate', handlePopstate);
})();